// eslint-disable-next-line
import React from "react";
import './CollectView.css';
import collectBanner from '../../images/collect-banner.jpg';
import { ApplicationState } from "../../store";
import { ConnectedProps, connect } from 'react-redux';
import * as CollectReducer from "../../store/CollectReducer";
import * as MessageReducer from "../../store/MessageReducer";
import { RouteComponentProps } from "react-router";
import { getSiteInfo } from "../../services/CollectService";

// ------------------------------------------------------------------------------------------------
// component

const connector = connect(
    (state: ApplicationState) => ({ collectState: state.collectState, messageState: state.messageState }),
    { ...CollectReducer.actionCreators, ...MessageReducer.actionCreators }
);

type PropsFromRedux = ConnectedProps<typeof connector>

interface State { }

interface RouteParams {
    code: string;
}

interface Props extends RouteComponentProps<RouteParams>, PropsFromRedux { }


class CollectView extends React.Component<Props, State> {

    // --------------------------------------------------------------------------------------------
    // states

    private working: boolean = false;

    // --------------------------------------------------------------------------------------------
    // lifecycle

    componentDidMount() {
        this.loadSiteInfo();
    }

    // --------------------------------------------------------------------------------------------
    // data

    loadSiteInfo = () => {

        if (this.working) {
            return;
        }

        // load
        this.working = true;

        getSiteInfo(this.props.match.params.code).then(response => {
            this.working = false;
            if (!response.success) {
                alert(response.errorMessage);
            }
            else {
                this.props.setSiteInfo(response.data);
                if (response.data) {
                    document.title = `${response.data.siteName} | Steel & Tube Site Information`;
                } else {
                    // TODO: TO 404 PAGE
                }
            }
        }).catch(error => {
            this.working = false;
            alert(error);
        });
    }



    public render() {

        const { siteInfo } = this.props.collectState;

        return (
            <>
            {siteInfo &&  <div className="collect-view-container">
                <img src={collectBanner} alt="Webshop Registration" />

                <div className="collect-view-body">
                    <h5>Steel & Tube {siteInfo.siteName} Site Information</h5>

                    {siteInfo.locationPageUrl &&
                        <div>
                            <a href={siteInfo.locationPageUrl}>Branch location & contact</a>
                        </div>}

                    {siteInfo.collectTimes &&
                        <div>
                            <h6>
                                Collect Times
                            </h6>

                            <p>{siteInfo.collectTimes}</p>
                        </div>}

                    {siteInfo.parkingOnSite &&
                        <div>
                            <h6>
                                Parking on site
                            </h6>

                            <p>{siteInfo.parkingOnSite} </p>
                        </div>}


                    {siteInfo.verification &&
                        <div>
                            <h6>
                                Verification
                            </h6>

                            <p>{siteInfo.verification} </p>
                        </div>
                    }

                    {siteInfo.cutting &&
                        <div>
                            <h6>
                                Cutting
                            </h6>

                            <p>{siteInfo.cutting}</p>
                        </div>
                    }

                    {siteInfo.backOrders &&
                        <div>
                            <h6>
                                Backorders
                            </h6>

                            <p>{siteInfo.backOrders} </p>
                        </div>
                    }

                </div>
            </div>}
            </>
        );
    };
};

export default connector(CollectView);